import { LastDateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { DEFAULT_COMPARE_TO_PREVIOUS_PERIOD } from '@modules/quantify/constants';
import { CompareToPreviousPeriod } from '@modules/quantify/store/types';

export const getCompareToPreviousPeriodFromDuration = (
  duration: LastDateTimeRange,
): CompareToPreviousPeriod => {
  return {
    type: 'offset',
    value: duration.value ?? DEFAULT_COMPARE_TO_PREVIOUS_PERIOD.value,
    unit: duration.unit,
  };
};
